import { render, staticRenderFns } from "./FileInfoView.vue?vue&type=template&id=57d36228&scoped=true&"
import script from "./FileInfoView.vue?vue&type=script&lang=js&"
export * from "./FileInfoView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=57d36228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d36228",
  null
  
)

export default component.exports